import React from 'react';
import { useParams } from 'react-router-dom';
import TemporaryOrderViewer from '../components/TemporaryOrderViewer/TemporaryOrderViewer';

const TemporaryOrderWrapper = () => {
  const { token } = useParams();
  
  return <TemporaryOrderViewer token={token} />;
};

export default TemporaryOrderWrapper;